import React from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from 'formlabs-web-components/BaseComponents/DisplayComponent';

import Grid from 'formlabs-web-components/Grid/Grid';
import Cell from 'formlabs-web-components/Grid/Cell';
import Section from 'formlabs-web-components/Grid/Section';

const BasicTileGroup = ({ tileGroupId, children, navTitle, numOfCols }) => (
  <Section
    hasContainer
    sectionId={tileGroupId}
    marginBefore="6rem"
    marginBeforeSmall="6rem"
    marginBeforeMedium="6rem"
  >
    <Grid direction="x">
      {React.Children.map(children, child => (
        <Cell
          largeSize={`${Math.floor(24 / numOfCols)}`}
          mediumSize="12"
          key={child.ctaText}
        >
          {child}
        </Cell>
      ))}
    </Grid>
  </Section>
);

BasicTileGroup.propTypes = {
  children: PropTypes.node
};

export default DisplayComponent(BasicTileGroup);
